export const ROLES = [
    { id: 1, label: "Admin" },
    { id: 2, label: "Operation" },
    { id: 3, label: "Engineer" },
    { id: 4, label: "BDM" },
    { id: 5, label: "Account" },
    { id: 6, label: "Head" },
    { id: 7, label: "Enterprise" },
    { id: 8, label: "Enterprise BDM" },
    { id: 9, label: "Enterprise Ops" },
    { id: 10, label: "Enterprise Admin" },
    { id: 11, label: "Legal Officer" },
  ];
  
  export const getRoleNames = (roleIds) => {
    if (!roleIds || !Array.isArray(roleIds)) {
      return [];
    }
    const allRoleIds = ROLES.map(role => role.id);
    const isAllUsers = roleIds.length === allRoleIds.length && allRoleIds.every(id => roleIds.includes(id));
    if (isAllUsers) {
      return ["All Users"];
    }
    return roleIds.map(id => {
      const role = ROLES.find(r => r.id === id);
      return role ? role.label : `Role ${id}`;
    });
  };